// extracted by mini-css-extract-plugin
export default {"cmsPromoContentWrapper":"CmsPromoEditModal_cmsPromoContentWrapper__4tay4","trailContentWrapper":"CmsPromoEditModal_trailContentWrapper__-5QhK"};